<template>
  <div class="wrapper-up day-pdf-layout">
    <div class="wrapper pb-0">
      <header class="header" id="campusesLogo">
        <div class="compos">
          <img :src="selectedCampus.logo" />
        </div>
        <div
          @click="download"
          class="btn btn--short-md btn--border-grey pl-2 pr-2 mr-4"
        >
          <icon class="ml-0" name="downloadExcel-1" width="25" />
        </div>
        <div class="header-date">
          מרכז למידה<span>{{ pageDay }}</span>
        </div>
        <div class="logo">
          <svg
            width="103"
            height="40"
            viewBox="0 0 103 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M45.9508 28.1004C45.4901 28.8454 44.8956 29.4385 44.1669 29.8791C43.4383 30.3197 42.5447 30.5402 41.4863 30.5402C40.7391 30.5402 40.0571 30.4099 39.4407 30.1492C38.8242 29.8883 38.2918 29.5346 37.8434 29.0876C37.3951 28.6405 37.0462 28.1161 36.7974 27.5138C36.5481 26.9115 36.4238 26.263 36.4238 25.5676C36.4238 24.8722 36.5481 24.2203 36.7974 23.6118C37.0465 23.0036 37.3953 22.4759 37.8434 22.0288C38.2918 21.5821 38.8242 21.2281 39.4407 20.9672C40.0571 20.7065 40.7388 20.5762 41.4863 20.5762C42.5447 20.5762 43.4445 20.8063 44.1855 21.2654C44.9262 21.7247 45.521 22.327 45.9694 23.072L43.9333 24.3383C43.684 23.9412 43.379 23.609 43.018 23.3419C42.6565 23.0751 42.1775 22.9417 41.5796 22.9417C40.8198 22.9417 40.2067 23.1839 39.7398 23.6682C39.2729 24.1525 39.0393 24.7856 39.0393 25.5679C39.0393 26.3501 39.2729 26.9866 39.7398 27.4768C40.2067 27.9676 40.8201 28.2128 41.5796 28.2128C42.1775 28.2128 42.6565 28.0794 43.018 27.8123C43.379 27.5455 43.684 27.2134 43.9333 26.8159L45.9508 28.1004Z"
              fill="#38455D"
            />
            <path
              d="M53.8346 29.6099C53.4984 29.8705 53.0843 30.0754 52.5924 30.2245C52.1001 30.3733 51.5804 30.4482 51.0325 30.4482C50.3722 30.4482 49.7498 30.324 49.1645 30.0757C48.579 29.8273 48.0685 29.486 47.6328 29.0513C47.1968 28.6168 46.8482 28.1048 46.5865 27.5148C46.3251 26.9251 46.1943 26.2824 46.1943 25.5871C46.1943 24.9043 46.3251 24.2619 46.5865 23.6593C46.8482 23.057 47.1965 22.5357 47.6328 22.0948C48.0685 21.6542 48.579 21.3064 49.1645 21.0517C49.7498 20.7974 50.3722 20.6699 51.0325 20.6699C51.5804 20.6699 52.1001 20.7476 52.5924 20.9028C53.084 21.0581 53.4984 21.2661 53.8346 21.5267V20.7633H56.4312V30.3178H53.8346V29.6099ZM51.2565 23.0164C50.895 23.0164 50.5622 23.0848 50.2572 23.2213C49.9519 23.358 49.6874 23.5411 49.4633 23.7709C49.239 24.0007 49.0616 24.2737 48.9309 24.5901C48.8002 24.9068 48.7347 25.2392 48.7347 25.5868C48.7347 25.9472 48.8002 26.2822 48.9309 26.5924C49.0616 26.903 49.239 27.1762 49.4633 27.4119C49.6877 27.6479 49.9519 27.831 50.2572 27.9613C50.5622 28.0919 50.8953 28.1569 51.2565 28.1569C51.6301 28.1569 51.9756 28.0919 52.2933 27.9613C52.6109 27.831 52.8878 27.6479 53.1245 27.4119C53.3609 27.1762 53.5448 26.903 53.6755 26.5924C53.8062 26.2822 53.8717 25.9469 53.8717 25.5868C53.8717 25.2392 53.8031 24.9068 53.6662 24.5901C53.529 24.2737 53.3424 24.0004 53.1059 23.7709C52.8692 23.5411 52.5924 23.358 52.2747 23.2213C51.9571 23.0848 51.6178 23.0164 51.2565 23.0164Z"
              fill="#38455D"
            />
            <path
              d="M60.0369 21.7115C60.1611 21.5873 60.3076 21.4601 60.476 21.3295C60.6441 21.1991 60.8403 21.0781 61.0643 20.9662C61.2887 20.8547 61.5343 20.7647 61.8022 20.6963C62.0699 20.6282 62.3656 20.5938 62.6897 20.5938C63.2376 20.5938 63.745 20.6963 64.2122 20.9012C64.6791 21.1061 65.087 21.4385 65.4358 21.8976C65.8094 21.5004 66.2513 21.1837 66.7621 20.9477C67.2726 20.712 67.8764 20.5938 68.5741 20.5938C69.1594 20.5938 69.6825 20.684 70.1433 20.8639C70.6037 21.0439 70.9962 21.3014 71.3203 21.6367C71.6438 21.9719 71.8901 22.3724 72.0582 22.8379C72.2263 23.3034 72.3103 23.8222 72.3103 24.3932V30.3159H69.7323V24.8217C69.7323 24.2631 69.5923 23.8161 69.312 23.4809C69.0318 23.1459 68.6363 22.978 68.126 22.978C67.5405 22.978 67.0705 23.1613 66.7157 23.5277C66.361 23.894 66.1833 24.4002 66.1833 25.0454V30.3162H63.6241V24.8217C63.6241 24.2631 63.4841 23.8161 63.2038 23.4809C62.9236 23.1459 62.5281 22.978 62.0179 22.978C61.4323 22.978 60.9623 23.1613 60.6075 23.5277C60.2528 23.894 60.0751 24.4002 60.0751 25.0454V30.3162H57.4785V20.7616H60.0377V21.7115H60.0369Z"
              fill="#38455D"
            />
            <path
              d="M78.7532 30.4462C78.205 30.4462 77.6852 30.3686 77.1933 30.2133C76.7011 30.058 76.2873 29.8501 75.9511 29.5894V33.5937H73.3545V20.7613H75.9511V21.5063C76.2873 21.2456 76.7011 21.0407 77.1933 20.8916C77.685 20.7428 78.205 20.668 78.7532 20.668C79.4006 20.668 80.0201 20.7921 80.6119 21.0405C81.2033 21.2891 81.7169 21.6302 82.1529 22.0649C82.5886 22.4996 82.9375 23.0144 83.1992 23.6106C83.4606 24.2067 83.5913 24.8463 83.5913 25.5291C83.5913 26.2247 83.4606 26.8699 83.1992 27.466C82.9375 28.0622 82.5889 28.5807 82.1529 29.0213C81.7169 29.4622 81.203 29.81 80.6119 30.0645C80.0201 30.3187 79.4006 30.4462 78.7532 30.4462ZM78.5289 23.0147C78.1553 23.0147 77.8098 23.08 77.4921 23.2103C77.1745 23.3407 76.8973 23.524 76.6609 23.76C76.4242 23.996 76.2406 24.2692 76.1099 24.5792C75.9792 24.8898 75.9137 25.225 75.9137 25.5851C75.9137 25.9455 75.982 26.2805 76.1192 26.5907C76.2561 26.9013 76.443 27.1712 76.6797 27.401C76.9161 27.6311 77.1933 27.8141 77.511 27.9504C77.8286 28.0871 78.1679 28.1552 78.5291 28.1552C78.8777 28.1552 79.2077 28.0871 79.5192 27.9504C79.8304 27.8141 80.0983 27.6311 80.3223 27.401C80.5466 27.1712 80.724 26.9013 80.8547 26.5907C80.9854 26.2805 81.0509 25.9453 81.0509 25.5851C81.0509 25.225 80.9854 24.8898 80.8547 24.5792C80.724 24.2692 80.5466 23.996 80.3223 23.76C80.098 23.524 79.8301 23.3407 79.5192 23.2103C79.2074 23.08 78.8774 23.0147 78.5289 23.0147Z"
              fill="#38455D"
            />
            <path
              d="M90.9508 30.3163V29.3664C90.6267 29.7143 90.2284 29.9875 89.7553 30.186C89.2819 30.3844 88.7528 30.4839 88.1676 30.4839C87.6073 30.4839 87.0996 30.3908 86.6451 30.2045C86.1903 30.0184 85.8012 29.7574 85.4774 29.4222C85.1533 29.087 84.9045 28.6834 84.7302 28.2117C84.5556 27.7397 84.4688 27.2122 84.4688 26.6284V20.7617H87.0465V26.1817C87.0465 26.7529 87.2022 27.2153 87.5134 27.569C87.8246 27.923 88.2606 28.0999 88.8211 28.0999C89.4562 28.0999 89.9667 27.9135 90.3529 27.541C90.7389 27.1685 90.932 26.6472 90.932 25.9765V20.7617H93.5098V30.3163H90.9508Z"
              fill="#38455D"
            />
            <path
              d="M97.0409 27.3184C97.0409 27.4672 97.0687 27.6166 97.125 27.7654C97.1809 27.9143 97.2773 28.051 97.4145 28.1752C97.5514 28.2997 97.7322 28.4053 97.9562 28.4919C98.1805 28.5788 98.4667 28.6222 98.8155 28.6222C99.3013 28.6222 99.6591 28.5292 99.8897 28.3428C100.12 28.1564 100.235 27.9516 100.235 27.7282C100.235 27.5791 100.191 27.4521 100.104 27.3462C100.017 27.2408 99.8986 27.1573 99.7494 27.0948C99.5998 27.0328 99.4225 26.9801 99.217 26.9364C99.0115 26.893 98.7902 26.8526 98.5538 26.8153C98.1302 26.7408 97.6852 26.66 97.2183 26.5732C96.7514 26.4866 96.3216 26.3403 95.9291 26.1354C95.537 25.9308 95.2129 25.6418 94.9576 25.2693C94.7021 24.8968 94.5748 24.3879 94.5748 23.7421C94.5748 23.3077 94.6681 22.9041 94.855 22.5316C95.042 22.1591 95.3062 21.8334 95.6489 21.5537C95.9913 21.2743 96.4053 21.0543 96.8911 20.8925C97.3768 20.7311 97.9247 20.6504 98.535 20.6504C99.7553 20.6504 100.727 20.936 101.449 21.5072C102.171 22.0784 102.57 22.848 102.645 23.8167H100.048C100.036 23.6429 100.008 23.4814 99.9644 23.3323C99.9206 23.1835 99.843 23.0563 99.7308 22.9506C99.6187 22.8452 99.4694 22.7614 99.2825 22.6992C99.0958 22.6373 98.8588 22.6061 98.5727 22.6061C98.1991 22.6061 97.8783 22.6715 97.6107 22.8018C97.3428 22.9321 97.2093 23.1462 97.2093 23.4442C97.2093 23.6182 97.2652 23.764 97.3774 23.882C97.4896 24 97.645 24.0961 97.8443 24.1706C98.0433 24.2452 98.2738 24.3074 98.5356 24.357C98.7973 24.4066 99.0711 24.4565 99.3575 24.5059C99.7685 24.5801 100.189 24.6642 100.619 24.7573C101.048 24.8503 101.441 24.9966 101.795 25.195C102.15 25.3938 102.44 25.6575 102.664 25.9865C102.888 26.3156 103 26.7472 103 27.2811C103 27.8523 102.888 28.3397 102.664 28.743C102.44 29.1466 102.134 29.4788 101.749 29.7394C101.362 30.0001 100.905 30.1929 100.376 30.3168C99.8464 30.4407 99.283 30.5032 98.6851 30.5032C98.0248 30.5032 97.4364 30.4222 96.9198 30.261C96.4028 30.0996 95.9606 29.8762 95.5935 29.5903C95.2261 29.3047 94.9396 28.9695 94.7342 28.5847C94.5287 28.1999 94.4196 27.7775 94.4072 27.3181H97.0409V27.3184Z"
              fill="#38455D"
            />
            <path
              d="M12.248 34.9817C8.13398 34.9817 4.78711 31.6448 4.78711 27.543H7.72412C7.72412 30.0298 9.75344 32.0534 12.248 32.0534V34.9817Z"
              fill="#38455D"
            />
            <path
              d="M25.5499 0V4.19908L34.6297 13.2974L40.6983 7.26949V18.0609H43.687V0L34.6297 9.03018L25.5499 0ZM61.0474 12.0557L55.0019 0.00056055L45.9434 18.0612H49.294L50.8358 15.0353L52.3288 12.0557L55.0016 6.7507L57.6499 12.0557H54.1793L52.8112 15.0572H59.1479L60.6482 18.0612H64.06L62.5524 15.0572L61.0474 12.0557ZM75.43 9.41528C76.1544 8.3976 76.4945 7.27033 76.4945 6.00629C76.4945 4.35659 75.907 2.9583 74.7297 1.76013C73.5499 0.586335 72.123 0.00056055 70.471 0.00056055H60.6237L62.178 3.07546L70.471 3.02417C71.2859 3.02417 71.9884 3.31958 72.5784 3.90507C73.1879 4.49309 73.4839 5.19125 73.4839 6.00629C73.4839 6.84095 73.1876 7.56322 72.5784 8.14899C71.9887 8.73701 71.2862 9.0299 70.471 9.0299L68.0211 9.01028L72.5956 18.0612H75.9143L72.5146 11.5824C73.5772 11.1527 74.73 10.4304 75.43 9.41528ZM77.4826 0L79.1291 3.02501H85.1524V18.0606H88.1864V3.02501H94.2097V0H77.4826ZM22.0164 24.7172L22.0521 27.5423C22.0521 32.7969 17.7646 37.0717 12.4947 37.0717C7.22448 37.0717 2.93702 32.7969 2.93702 27.5423C2.93702 22.6078 6.71876 18.5377 11.5445 18.0606H20.2513C21.7232 18.0606 22.9685 17.5413 23.9872 16.5256C25.0287 15.4872 25.5499 14.2455 25.5499 12.8004C25.5499 11.3556 25.0287 10.1137 23.9872 9.0753C22.9685 8.05931 21.7232 7.54024 20.2513 7.54024H15.7454C15.0885 7.54024 14.5681 7.31434 14.1147 6.86309C13.6843 6.41157 13.4808 5.89222 13.4808 5.2602C13.4808 4.96647 13.5264 4.6733 13.6396 4.40228C13.7524 4.13125 13.9112 3.88293 14.1147 3.67973C14.3413 3.45411 14.5679 3.29603 14.8619 3.18308C15.134 3.07013 15.4283 3.02501 15.7454 3.02501V0C14.2735 0 13.0282 0.519069 12.0092 1.55749C10.9905 2.59619 10.4696 3.8151 10.4696 5.2602C10.4696 6.72744 10.9908 7.96934 12.0092 9.00776C13.0285 10.0238 14.2735 10.5428 15.7454 10.5428H20.2513C20.8852 10.5428 21.4064 10.7687 21.859 11.22C22.2891 11.6715 22.5381 12.1908 22.5381 12.8004C22.5381 13.1163 22.4704 13.41 22.3571 13.6811C22.2438 13.9745 22.0855 14.2001 21.8814 14.4033C21.6779 14.6065 21.4289 14.7646 21.1343 14.8773C20.8627 14.9902 20.4678 15.0575 20.1509 15.0575L12.4947 15.085C5.60501 15.085 0 20.6734 0 27.5423C0 34.4116 5.60501 40 12.4947 40C19.3447 40 24.925 34.4752 24.9885 27.6421L33.1705 27.6323L33.1668 24.704L22.0164 24.7172ZM12.2482 29.2601V27.5426H10.4693C10.726 29.2601 12.2482 29.2601 12.2482 29.2601Z"
              fill="#409FFF"
            />
          </svg>
        </div>
      </header>
      <!--      <TheSidebarOld @showMenu="changeShowMenu" />-->
      <main class="main main--tablet pr-0">
        <!--        Content        -->
        <slot></slot>
      </main>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'LayoutDefault',
  computed: {
    ...mapState({
      campuses: s => s.settings.campuses,
      selectedCampus: s => s.settings.selectedCampus
    }),
    pageDay() {
      let day = new Date();
      if (this.$route.query.day) {
        day = new Date(this.$route.query.day);
      }
      const weekFormatter = new Intl.DateTimeFormat('he-IL', {
        weekday: 'narrow'
      });
      const monthFormatter = new Intl.DateTimeFormat('he-IL', {
        month: 'short'
      });
      const results =
        weekFormatter.format(day) +
        ', ' +
        day.getDate() +
        ' ' +
        monthFormatter.format(day);
      return results;
    }
  },
  methods: {
    download() {
      const kanban = document.getElementById('kanban-print');
      let stylesHtml = '';
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=1,scrollbars=1,status=1'
      );

      WinPrint.document.write(`<!DOCTYPE html>
        <html dir="rtl">
          <head>
            <title>מרכז למידה | ${this.pageDay}  </title>
            ${stylesHtml}
            <style>
            
            .lesson-template__group{
              color:#FF3826 !important;
            }
            .teacher-template__header{
              overflow:hidden;
            }
            .teacher-template__settings-wrap{
              opacity:0;
            } 
            .day-split-header .teacher-template__header {
            border-top: 0px !important;
            display: flex;
            flex-direction: row-reverse;
            align-content: center;
            justify-content: flex-end;
  
             }
             .day-split-header {
              height: 40px !important;
  
             }
    
            .h4{
              font-size:14px !important;
              text-align: right;
            }
              .lesson-template{
                height:100%;
                width:100%;
              }
            
              .vuecal__time-column {
                 width: 3em;
                 height: 100%;
                 flex-shrink: 0;
                 margin-top: 45px !important;
               }
              @media print {
       
                .lesson-template__list-item {
                  margin-left:0px !important;
                }
                .lesson-template__list-item-title{
                  font-size: 8px !important;
                   line-height: 10px !important;
                }
                .lesson-template__time-header .lesson-template__time{
                  font-weight: 400;
                  font-size: 8px !important;
                  line-height: 11px !important;
                }
                .lesson-template__group {
                font-size: 9px !important;
                line-height: 10px !important;
                }
               
                html, body {
                  overflow: scroll;
                  width:100%;
                  min-width: 1200px;
                  height:auto;
                  margin:auto;
                  padding:0;
                  page-break-after: auto;
                  page-break-before: auto;
                  /*transform: scale(0.7);*/
                }
                @page {
                  /*size: A3 landscape;*/
                  min-width: 1200px;
                  print-color-adjust: exact;
                  
                  -webkit-print-color-adjust: exact;
                }
              }
            </style>
          </head>
          <body>
            <div class="study-center-new is-pdf">
              <div class="vuecal--blue-theme  vuecal vuecal--blue-theme  vuecal--he vuecal--view-with-time vuecal--split-days vuecal--sticky-split-labels ">
              ${kanban.innerHTML}
              </div>
              </div>
          </body>
        </html>`);

      setTimeout(() => {
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        setTimeout(function () {
          WinPrint.close();
        }, 1);
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  //padding-right: 0;
  padding: 8px 8px 8px;

  .compos {
    img {
      height: auto;
      max-width: 100px;
    }
  }

  &-date {
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: #38455d;
    flex: 1;
    text-align: center;

    span {
      font-weight: 500;
      color: #409fff;
      padding-right: 32px;
      position: relative;
      display: inline-flex;
      align-items: center;

      &::before {
        content: '';
        position: absolute;
        height: 16px;
        width: 1px;
        background-color: #929baa;
        right: 16px;
      }
    }
  }
}
</style>
